<template>
  <div>
    <!-- ems航空-->
    <div id="printPage" ref="print">
      <div class="left">
        <span style="left: 0px; top: 100px">RAKUMART</span><!--寄件人-->
        <span style="left: 0px; top: 178px">RAKUMART</span><!--公司。-->
        <span style="left: 0px; top: 211px" v-html="$parent.textToHtml(companyAddress)"></span>
        <!--公司地址。-->
        <span style="left: 0px; top: 288px">322000</span><!--公司。-->
        <span style="left: 108px; top: 330px; font-size: 16px;">√</span><!--公司。-->
        <span style="left: 158px; top: 100px">{{ mobile }}</span><!--电话。-->
        <span style="left: 228px; top: 138px">china</span><!--国家。-->
        <span style="left: 0px; top: 494px; word-break: break-all; width: 250px"></span>
        <!--备注。-->
        <span style="left: 145px; top: 70px">{{
          specifiedFormatDate({ format: "yyyy" })
        }}</span>
        <span style="left: 200px; top: 70px">{{
          specifiedFormatDate({ format: "mm" })
        }}</span>
        <span style="left: 250px; top: 70px">{{
          specifiedFormatDate({ format: "dd" })
        }}</span>
        <span style="left: 30px; top: 400px;width: 800px;">インボイスを参照ください<br>
          <span v-if="receiver.bank_no">リアルタイム口座 :{{ receiver.bank_no }}</span><br>
          <span v-if="receiver.standard_no">輸出入者標準コード: {{ receiver.standard_no }}</span>
          <!-- <br>インボイスを参照ください<br>インボイスを参照ください -->
        </span>
      </div>
      <div class="right">
        <span style="left: 608px; top: 0px">{{ $route.query.sn || "" }} {{ $route.query.p_username }}</span>
        <span style="left: 456px; top: 65px">{{ receiver.contacts }}様</span><!--名称-->
        <span style="left: 619.4px; top: 107px">日本</span><!--名称-->
        <span style="left: 400px; top: 178px" v-html="$parent.textToHtml(receiver.address)"></span><!--地址-->
        <span style="left: 456px; top: 250px">{{ receiver.zip_code }}</span><!--地址-->
        <span style="left: 619.4px; top: 250px">{{ receiver.mobile }}</span>
        <!-- 重量 -->
        <span style="left: 619.4px; top: 287px;font-size:18px;font-weight: 600;">{{ $route.query.weight }}</span>
        <!-- 长宽高 -->
        <span style="left:420px; top: 278px;font-size:22px;font-weight: 600;">{{ volume }}</span>



        <!--地址-->
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" @click="save"> 复制页面代码数据</el-button>
      <el-button type="primary" @click="print"> 打印</el-button>
    </div>
  </div>
</template>
<script>
import { specifiedFormatDate } from "@/utlis/date";
import { mapState } from "vuex";
export default {
  data() {
    return { specifiedFormatDate, volume: '' };
  },
  computed: {
    ...mapState({
      receiver: (state) => state.porderDetail.receiver, //进口商信息
    }),
    companyAddress() {
      switch (this.$route.query.department) {
        case "一部":
          return `3th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        case "二部":
          return `4th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        case "三部":
          return `5th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        case "四部":
          return `3th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        default:
          break;
      }
      return;
    },
    mobile() {
      switch (this.$route.query.department) {
        case "一部":
          return `15067546083`;
          break;
        case "二部":
          return `18606888793`;
          break;
        case "三部":
          return `18268222365`;
          break;
        case "四部":
          return `15067546083`;
          break;
        default:
          break;
      }
      return;
    },
  },
  created() {
    this.getLogisticsAmountBatch()
    // this.print()
  },
  methods: {
    // 计算抛重
    getLogisticsAmountBatch() {
      let query = this.$route.query
      let datas = {
        list: [{
          logistics_id: 1,
          freight: [{
            weight: query.weight,
            volume: query.height * query.width * query.length,
          }]
        }]
      }
      this.$api.porderApi.getLogisticsAmountBatch(datas).then(res => {
        let volumeweight = res.data[0].calculation_result.volumeWeight
        if (volumeweight >= 10.1 && volumeweight <= 12.5 && query.weight >= 8 && query.weight <= 10) {
          this.volume = `${query.length} * ${query.width}  *  ${query.height} `
        } else {
          this.volume = `${query.length == 60 ? 59.6 : query.length} * ${query.width == 60 ? 59.6 : query.width}  *  ${query.height == 60 ? 59.6 : query.height} `
        }
      })
      // console.log(datas);
    },
    print() {
      this.$nextTick(() => {
        this.$print(this.$refs.print);
      });
      // this.$print(this.$refs.print)
    },
    save() {
      let copyUrl = this.$refs.print.innerHTML;
      let oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = copyUrl; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
      // console.log(copyUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  margin: 20px auto;
  text-align: center;
}

.left {
  float: left;
  width: 435px;
  height: 583px;

  left: 0;
}

.right {
  float: right;
  width: 435px;
  height: 583px;

  left: 0;
  /*right: 0;*/
}

#printPage {
  width: 874px;
  height: 585px;
  position: relative;
}

span {
  font-size: 14px;

  position: absolute;
  color: #000;

}
</style>
